// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      id="SenzaraIcon__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 310.51 58.57"
      {...props}
    >
      <defs>
        <style>
          {
            ".SenzaraIcon__cls-1{fill:#0b4b5b}.SenzaraIcon__cls-2,.SenzaraIcon__cls-3,.SenzaraIcon__cls-4,.SenzaraIcon__cls-5{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px}.SenzaraIcon__cls-2{stroke:#8accdd}.SenzaraIcon__cls-3{stroke:#67bed3}.SenzaraIcon__cls-4{stroke:#2e8093}.SenzaraIcon__cls-5{stroke:#51a8bf}"
          }
        </style>
      </defs>
      <path
        className="SenzaraIcon__cls-1"
        d="M84.75 21.88v-.39c0-3.31-2.7-5.39-6.78-5.39-3.93 0-6.39 2-6.39 5.09s1.54 4.23 7.93 6c4.54 1.23 6.93 2.39 8.62 4.08A9.91 9.91 0 0 1 91 38.2c0 6.16-5.08 10.32-12.63 10.32-8.08 0-12.62-3.77-13.24-10.93h5.78c.38 4 3 6.16 7.46 6.16 4 0 6.63-2.08 6.63-5.24s-2-4.62-8.09-6.16c-7.7-2.08-11.16-5.31-11.16-10.7 0-6.16 5-10.32 12.47-10.32s12.09 3.85 12.4 10.55ZM102.69 31.81a11 11 0 0 0 2.31 6.47 11.52 11.52 0 0 0 9.54 4.85 12.31 12.31 0 0 0 10.63-6.08l5.16 1.95a17.39 17.39 0 0 1-15.79 9.55C104 48.52 96.45 40.82 96.45 30s7.47-18.71 17.86-18.71 18 7.78 18 18.17c0 .46 0 1.46-.08 2.31Zm23.4-4.31a11 11 0 0 0-2-6.08 12.15 12.15 0 0 0-9.78-4.85 11.41 11.41 0 0 0-9.55 4.92 14.22 14.22 0 0 0-2 6ZM146 12.18v5c3.08-4.16 6.16-5.85 10.55-5.85a12.36 12.36 0 0 1 8.24 2.93c2.23 2.15 3 4.62 3 9.47v23.94h-5.89V25c0-3.16-.39-4.85-1.31-6.09a6.85 6.85 0 0 0-5.54-2.38 8.84 8.84 0 0 0-6.78 3A8.4 8.4 0 0 0 146 26v21.67h-5.85V12.18ZM199.93 42.51v5.16h-26.17l18.48-30.33h-16.48v-5.16h26.1l-18.25 30.33ZM233.12 12.18H239v35.49h-5.85v-6.85c-3.54 5.31-7.54 7.7-12.93 7.7-9.78 0-16.71-7.7-16.71-18.48s7.08-18.71 16.86-18.71c5.39 0 9.32 2.08 12.78 6.7Zm-20.56 8.62a16.25 16.25 0 0 0-2.92 9.39c0 7.55 4.92 13.25 11.39 13.25 6.7 0 12.17-6.24 12.17-13.86s-4.93-13-12-13c-3.86-.01-6.56 1.3-8.64 4.22ZM255.91 12.18v6c1.08-2.54 1.85-3.62 3.24-4.69a11.08 11.08 0 0 1 6.77-2.16h1.39v5.93a12.65 12.65 0 0 0-1.62-.08 9.13 9.13 0 0 0-7.7 4.08c-1.54 2.24-2.08 4.32-2.08 8.4v18h-5.85V12.18ZM299.42 12.18h5.85v35.49h-5.85v-6.85c-3.54 5.31-7.55 7.7-12.94 7.7-9.78 0-16.71-7.7-16.71-18.48s7.09-18.71 16.87-18.71c5.39 0 9.31 2.08 12.78 6.7Zm-20.56 8.62a16.18 16.18 0 0 0-2.93 9.39c0 7.55 4.93 13.25 11.4 13.25 6.7 0 12.17-6.24 12.17-13.86s-4.93-13-12-13c-3.87-.01-6.56 1.3-8.64 4.22Z"
      />
      <circle className="SenzaraIcon__cls-2" cx={29.42} cy={30} r={9.38} />
      <ellipse
        className="SenzaraIcon__cls-3"
        cx={29.42}
        cy={30}
        rx={13.57}
        ry={13.88}
      />
      <circle className="SenzaraIcon__cls-4" cx={29.42} cy={30} r={22.52} />
      <circle className="SenzaraIcon__cls-5" cx={29.42} cy={30} r={17.89} />
    </svg>
  );
};

const SenzaraIcon = Icon;
export default SenzaraIcon;
